import React from 'react';
import {
    Link, LinkingIOS
} from 'react-router-dom';
import RegisterClasses from './RegisterClasses.js';
import DatePickerDropdown from './DatePickerDropdown.js';
import moment from 'moment';
import '../App.css';
import config from '.././config.json';
import $ from 'jquery';
import {
    Form, Input, Select, Checkbox,
    Steps, DatePicker, Modal, Table, Icon, Menu, Alert, Radio, Row, Col, Spin, Card
} from 'antd';
import usStates from '../usStates';
import Admin from '../Admin/Admin.js';

const Step = Steps.Step;
const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 },
    },
};

// From the UI go to the Search Student button on the top navigation bar. 
// This page searches for a student based on their last name
// and returns that students full name, email, and techID. 
class SearchStudent extends React.Component {

    constructor(props) {
        super(props);
        this.state.student = {
            Id: -1, FirstName: '', MiddleInitial: '', LastName: '', DLN: '', DateofBirth: '',
            StreetAddress: '', State: 'ND', City: '', ZipCode: '', PhoneNumber: '', Email: '', TechID: 'To be assigned'
        };
    }
    state = ({
        userVisible: false,
        visibleWarning: false,
        studentData: [],
        selectedRowKeys: [],
        selectedRows: [],
        studentFirstName: 'NA',
        studentLastName: 'NA',
    });

    render() {
        const { getFieldDecorator } = this.props.form;
        const { selectedRowKeys, selectedRows } = this.state;
        const rowSelection = {
            selectedRowKeys,
            selectedRows,
            onChange: this.onSelectChange,
        };
        const columns= [
            {
                title: 'First Name',
                dataIndex: 'FirstName',
            },
            {
                title: 'Middle I',
                dataIndex: 'MiddleInitial',
            },
            {
                title: 'Last Name',
                dataIndex: 'LastName',
            },
            {
                title: 'Employer',
                dataIndex: 'CompanyName',
                render: (text, record, index) => {
                    let emp = 'Not Available';
                    if (record.CompanyName) {
                        emp = record.CompanyName + ", " + record.EmployerCity + " (" + record.EmployerState + ")"
                    }
                    return (
                        <div>{emp}</div>
                    );
                },
            },
        ];
        return (
            <div>
                <br />
                <br />
                <Card style={{ width: 450 }}>
                    <Row>
                        <button style={{ color: 'black', float: 'right'}} className="btn btn-default" onClick={() => this.searchStudent()}>Search</button>
                        <FormItem label="Last Name: " style={{ width: 300, float: 'right' }} {...formItemLayout}>
                            {getFieldDecorator('lastName')(
                                <Input />
                            )}
                        </FormItem>
                    </Row>
                </Card>
                <br />
                    <div>
                    <br />
                    <Table rowKey="StudentId" columns={columns} dataSource={this.state.studentData} size="small" bordered />
                        <br />
                    </div>
            </div>
            
        );
    }

    //Search for student based off of last name
    searchStudent = () => {
        try {

            var LastNameEx = this.capitalize(this.props.form.getFieldValue('lastName'));

            if (LastNameEx) {

                this.existingUser = {LastName: LastNameEx };
                $.ajax({
                    type: 'POST',
                    url: `${config.serverUrl}/api/registration/searchtech`,
                    data: this.existingUser
                })
                    .done((data) => {

                        this.setState({
                            studentData: data
                        });
                    })
                    .fail((jqXhr) => {
                        console.log("Failed to search");
                    });
            }
            else {
                Modal.error({
                    title: 'Error message',
                    content: 'Last name is required',
                });
            }
        }
        catch (error) {
            console.log("ERROR: in SearchStudent");
        }
    }

    capitalize(str) {
        if (str) {
            return str.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
        }
    }

    componentDidMount() {
   
    }
}

const WrappedAdvancedSearchForm = Form.create()(SearchStudent);
export default WrappedAdvancedSearchForm;





// WEBPACK FOOTER //
// ./src/Registration/SearchStudent.js